import { createFrontendModule } from '@backstage/frontend-plugin-api';
import searchPlugin from '@backstage/plugin-search/alpha';
import { SearchContextProvider } from '@backstage/plugin-search-react';

const searchPageOverride = searchPlugin.getExtension('page:search').override({
  params: {
    path: '/search',
    loader: () =>
      import('../components/pages/search/SearchPage').then(m => (
        <SearchContextProvider>
          <m.CustomSearchPage />
        </SearchContextProvider>
      )),
  },
});

export const customSearchModule = createFrontendModule({
  pluginId: 'search',
  extensions: [searchPageOverride],
});
